import { getStandConfigDetail } from "@/shared/selectors/StandSelector";
import EditIcon from "@mui/icons-material/Edit";
import { Grid2, IconButton } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { STAND_TYPE_OPTIONS, SectionStand } from "../../../../models/Section";
import { StandTypeChip } from "./StandTypeChip";

type Props = {
	isM1: boolean;
	setOpenEdit: (open: boolean) => void;
	setSelectedData?: (data: any) => void;
};

export const useSectionStandsGridData = ({
	isM1,
	setOpenEdit,
	setSelectedData = () => {},
}: Props) => {
	const columnDefs: ColDef<SectionStand>[] = [
		{
			field: "StandName",
			headerName: "Stand",
			flex: 0.6,
		},
		{
			field: "SetpointGap",
			headerName: "Setpoint Gap",
			flex: 1,
		},
		{
			field: "StandTypeCode",
			headerName: "Type",
			flex: 1.2,
			hide: isM1,
			valueFormatter: ({ value }) =>
				STAND_TYPE_OPTIONS.find((o) => o.code === value)?.name ?? "",
			cellRenderer: ({ value }: ICellRendererParams) => (
				<StandTypeChip code={value} />
			),
		},
		{
			colId: "Config",
			headerName: "Config",
			flex: 1,
			hide: isM1,
			valueGetter: ({ data }) => (data ? getStandConfigDetail(data) : ""),
		},
		{
			field: "Area",
			headerName: "Area",
			flex: 1,
			hide: isM1,
		},
		{
			field: "Comments",
			headerName: "Comments",
			flex: 1.5,
			autoHeight: true,
			wrapText: true,
		},
		{
			colId: "actions",
			cellRenderer: (params: ICellRendererParams) => (
				<Grid2
					container
					sx={{
						height: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						opacity: 0,
						transition: "opacity 0.1s ease-in-out",
					}}
					className={`buttons`}
				>
					<Grid2
						size={{ xs: 12, md: 12 }}
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<IconButton
							onClick={() => {
								setOpenEdit(true);
								setSelectedData(params.data as SectionStand);
							}}
							title="Edit"
							size="small"
						>
							<EditIcon
								style={{ height: "auto" }}
								color="primary"
								fontSize="small"
							/>
						</IconButton>
					</Grid2>
				</Grid2>
			),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 50,
			filter: false,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
